module.exports = __webpack_public_path__ + "img/logo-linkedin.9e40031f.svg";